/* eslint-disable */
// This file generated by `npm run build:generate`, don't edit manually.

import { EntParams as EntParamsComplex, EntUnpacked as EntUnpackedComplex } from "./schema.js";
import { EntryTag as Tag } from "./constants.js";
/**
 * @category entry builder
 */
type EntParamsAccount1Type = EntParamsComplex & {
    tag: Tag.Account;
    version: 1;
};
/**
 * @category entry builder
 */
export interface EntParamsAccount1 extends EntParamsAccount1Type {
}
/**
 * @category entry builder
 */
type EntUnpackedAccount1Type = EntUnpackedComplex & {
    tag: Tag.Account;
    version: 1;
};
/**
 * @category entry builder
 */
export interface EntUnpackedAccount1 extends EntUnpackedAccount1Type {
}
/**
 * @category entry builder
 */
type EntParamsAccount2Type = Omit<EntParamsComplex & {
    tag: Tag.Account;
    version: 2;
}, "version"> & {
    version?: 2;
};
/**
 * @category entry builder
 */
export interface EntParamsAccount2 extends EntParamsAccount2Type {
}
/**
 * @category entry builder
 */
type EntUnpackedAccount2Type = EntUnpackedComplex & {
    tag: Tag.Account;
    version: 2;
};
/**
 * @category entry builder
 */
export interface EntUnpackedAccount2 extends EntUnpackedAccount2Type {
}
/**
 * @category entry builder
 */
type EntParamsName1Type = Omit<EntParamsComplex & {
    tag: Tag.Name;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category entry builder
 */
export interface EntParamsName1 extends EntParamsName1Type {
}
/**
 * @category entry builder
 */
type EntUnpackedName1Type = EntUnpackedComplex & {
    tag: Tag.Name;
    version: 1;
};
/**
 * @category entry builder
 */
export interface EntUnpackedName1 extends EntUnpackedName1Type {
}
/**
 * @category entry builder
 */
type EntParamsContract1Type = Omit<EntParamsComplex & {
    tag: Tag.Contract;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category entry builder
 */
export interface EntParamsContract1 extends EntParamsContract1Type {
}
/**
 * @category entry builder
 */
type EntUnpackedContract1Type = EntUnpackedComplex & {
    tag: Tag.Contract;
    version: 1;
};
/**
 * @category entry builder
 */
export interface EntUnpackedContract1 extends EntUnpackedContract1Type {
}
/**
 * @category entry builder
 */
type EntParamsContractCall2Type = Omit<EntParamsComplex & {
    tag: Tag.ContractCall;
    version: 2;
}, "version"> & {
    version?: 2;
};
/**
 * @category entry builder
 */
export interface EntParamsContractCall2 extends EntParamsContractCall2Type {
}
/**
 * @category entry builder
 */
type EntUnpackedContractCall2Type = EntUnpackedComplex & {
    tag: Tag.ContractCall;
    version: 2;
};
/**
 * @category entry builder
 */
export interface EntUnpackedContractCall2 extends EntUnpackedContractCall2Type {
}
/**
 * @category entry builder
 */
type EntParamsOracle1Type = Omit<EntParamsComplex & {
    tag: Tag.Oracle;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category entry builder
 */
export interface EntParamsOracle1 extends EntParamsOracle1Type {
}
/**
 * @category entry builder
 */
type EntUnpackedOracle1Type = EntUnpackedComplex & {
    tag: Tag.Oracle;
    version: 1;
};
/**
 * @category entry builder
 */
export interface EntUnpackedOracle1 extends EntUnpackedOracle1Type {
}
/**
 * @category entry builder
 */
type EntParamsChannel3Type = Omit<EntParamsComplex & {
    tag: Tag.Channel;
    version: 3;
}, "version"> & {
    version?: 3;
};
/**
 * @category entry builder
 */
export interface EntParamsChannel3 extends EntParamsChannel3Type {
}
/**
 * @category entry builder
 */
type EntUnpackedChannel3Type = EntUnpackedComplex & {
    tag: Tag.Channel;
    version: 3;
};
/**
 * @category entry builder
 */
export interface EntUnpackedChannel3 extends EntUnpackedChannel3Type {
}
/**
 * @category entry builder
 */
type EntParamsChannelOffChainUpdateTransfer1Type = Omit<EntParamsComplex & {
    tag: Tag.ChannelOffChainUpdateTransfer;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category entry builder
 */
export interface EntParamsChannelOffChainUpdateTransfer1 extends EntParamsChannelOffChainUpdateTransfer1Type {
}
/**
 * @category entry builder
 */
type EntUnpackedChannelOffChainUpdateTransfer1Type = EntUnpackedComplex & {
    tag: Tag.ChannelOffChainUpdateTransfer;
    version: 1;
};
/**
 * @category entry builder
 */
export interface EntUnpackedChannelOffChainUpdateTransfer1 extends EntUnpackedChannelOffChainUpdateTransfer1Type {
}
/**
 * @category entry builder
 */
type EntParamsChannelOffChainUpdateDeposit1Type = Omit<EntParamsComplex & {
    tag: Tag.ChannelOffChainUpdateDeposit;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category entry builder
 */
export interface EntParamsChannelOffChainUpdateDeposit1 extends EntParamsChannelOffChainUpdateDeposit1Type {
}
/**
 * @category entry builder
 */
type EntUnpackedChannelOffChainUpdateDeposit1Type = EntUnpackedComplex & {
    tag: Tag.ChannelOffChainUpdateDeposit;
    version: 1;
};
/**
 * @category entry builder
 */
export interface EntUnpackedChannelOffChainUpdateDeposit1 extends EntUnpackedChannelOffChainUpdateDeposit1Type {
}
/**
 * @category entry builder
 */
type EntParamsChannelOffChainUpdateWithdraw1Type = Omit<EntParamsComplex & {
    tag: Tag.ChannelOffChainUpdateWithdraw;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category entry builder
 */
export interface EntParamsChannelOffChainUpdateWithdraw1 extends EntParamsChannelOffChainUpdateWithdraw1Type {
}
/**
 * @category entry builder
 */
type EntUnpackedChannelOffChainUpdateWithdraw1Type = EntUnpackedComplex & {
    tag: Tag.ChannelOffChainUpdateWithdraw;
    version: 1;
};
/**
 * @category entry builder
 */
export interface EntUnpackedChannelOffChainUpdateWithdraw1 extends EntUnpackedChannelOffChainUpdateWithdraw1Type {
}
/**
 * @category entry builder
 */
type EntParamsChannelOffChainUpdateCreateContract1Type = Omit<EntParamsComplex & {
    tag: Tag.ChannelOffChainUpdateCreateContract;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category entry builder
 */
export interface EntParamsChannelOffChainUpdateCreateContract1 extends EntParamsChannelOffChainUpdateCreateContract1Type {
}
/**
 * @category entry builder
 */
type EntUnpackedChannelOffChainUpdateCreateContract1Type = EntUnpackedComplex & {
    tag: Tag.ChannelOffChainUpdateCreateContract;
    version: 1;
};
/**
 * @category entry builder
 */
export interface EntUnpackedChannelOffChainUpdateCreateContract1 extends EntUnpackedChannelOffChainUpdateCreateContract1Type {
}
/**
 * @category entry builder
 */
type EntParamsChannelOffChainUpdateCallContract1Type = Omit<EntParamsComplex & {
    tag: Tag.ChannelOffChainUpdateCallContract;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category entry builder
 */
export interface EntParamsChannelOffChainUpdateCallContract1 extends EntParamsChannelOffChainUpdateCallContract1Type {
}
/**
 * @category entry builder
 */
type EntUnpackedChannelOffChainUpdateCallContract1Type = EntUnpackedComplex & {
    tag: Tag.ChannelOffChainUpdateCallContract;
    version: 1;
};
/**
 * @category entry builder
 */
export interface EntUnpackedChannelOffChainUpdateCallContract1 extends EntUnpackedChannelOffChainUpdateCallContract1Type {
}
/**
 * @category entry builder
 */
type EntParamsTreesPoi1Type = Omit<EntParamsComplex & {
    tag: Tag.TreesPoi;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category entry builder
 */
export interface EntParamsTreesPoi1 extends EntParamsTreesPoi1Type {
}
/**
 * @category entry builder
 */
type EntUnpackedTreesPoi1Type = EntUnpackedComplex & {
    tag: Tag.TreesPoi;
    version: 1;
};
/**
 * @category entry builder
 */
export interface EntUnpackedTreesPoi1 extends EntUnpackedTreesPoi1Type {
}
/**
 * @category entry builder
 */
type EntParamsStateTrees0Type = Omit<EntParamsComplex & {
    tag: Tag.StateTrees;
    version: 0;
}, "version"> & {
    version?: 0;
};
/**
 * @category entry builder
 */
export interface EntParamsStateTrees0 extends EntParamsStateTrees0Type {
}
/**
 * @category entry builder
 */
type EntUnpackedStateTrees0Type = EntUnpackedComplex & {
    tag: Tag.StateTrees;
    version: 0;
};
/**
 * @category entry builder
 */
export interface EntUnpackedStateTrees0 extends EntUnpackedStateTrees0Type {
}
/**
 * @category entry builder
 */
type EntParamsMtree1Type = Omit<EntParamsComplex & {
    tag: Tag.Mtree;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category entry builder
 */
export interface EntParamsMtree1 extends EntParamsMtree1Type {
}
/**
 * @category entry builder
 */
type EntUnpackedMtree1Type = EntUnpackedComplex & {
    tag: Tag.Mtree;
    version: 1;
};
/**
 * @category entry builder
 */
export interface EntUnpackedMtree1 extends EntUnpackedMtree1Type {
}
/**
 * @category entry builder
 */
type EntParamsMtreeValue1Type = Omit<EntParamsComplex & {
    tag: Tag.MtreeValue;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category entry builder
 */
export interface EntParamsMtreeValue1 extends EntParamsMtreeValue1Type {
}
/**
 * @category entry builder
 */
type EntUnpackedMtreeValue1Type = EntUnpackedComplex & {
    tag: Tag.MtreeValue;
    version: 1;
};
/**
 * @category entry builder
 */
export interface EntUnpackedMtreeValue1 extends EntUnpackedMtreeValue1Type {
}
/**
 * @category entry builder
 */
type EntParamsContractsMtree1Type = Omit<EntParamsComplex & {
    tag: Tag.ContractsMtree;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category entry builder
 */
export interface EntParamsContractsMtree1 extends EntParamsContractsMtree1Type {
}
/**
 * @category entry builder
 */
type EntUnpackedContractsMtree1Type = EntUnpackedComplex & {
    tag: Tag.ContractsMtree;
    version: 1;
};
/**
 * @category entry builder
 */
export interface EntUnpackedContractsMtree1 extends EntUnpackedContractsMtree1Type {
}
/**
 * @category entry builder
 */
type EntParamsCallsMtree1Type = Omit<EntParamsComplex & {
    tag: Tag.CallsMtree;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category entry builder
 */
export interface EntParamsCallsMtree1 extends EntParamsCallsMtree1Type {
}
/**
 * @category entry builder
 */
type EntUnpackedCallsMtree1Type = EntUnpackedComplex & {
    tag: Tag.CallsMtree;
    version: 1;
};
/**
 * @category entry builder
 */
export interface EntUnpackedCallsMtree1 extends EntUnpackedCallsMtree1Type {
}
/**
 * @category entry builder
 */
type EntParamsChannelsMtree1Type = Omit<EntParamsComplex & {
    tag: Tag.ChannelsMtree;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category entry builder
 */
export interface EntParamsChannelsMtree1 extends EntParamsChannelsMtree1Type {
}
/**
 * @category entry builder
 */
type EntUnpackedChannelsMtree1Type = EntUnpackedComplex & {
    tag: Tag.ChannelsMtree;
    version: 1;
};
/**
 * @category entry builder
 */
export interface EntUnpackedChannelsMtree1 extends EntUnpackedChannelsMtree1Type {
}
/**
 * @category entry builder
 */
type EntParamsNameserviceMtree1Type = Omit<EntParamsComplex & {
    tag: Tag.NameserviceMtree;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category entry builder
 */
export interface EntParamsNameserviceMtree1 extends EntParamsNameserviceMtree1Type {
}
/**
 * @category entry builder
 */
type EntUnpackedNameserviceMtree1Type = EntUnpackedComplex & {
    tag: Tag.NameserviceMtree;
    version: 1;
};
/**
 * @category entry builder
 */
export interface EntUnpackedNameserviceMtree1 extends EntUnpackedNameserviceMtree1Type {
}
/**
 * @category entry builder
 */
type EntParamsOraclesMtree1Type = Omit<EntParamsComplex & {
    tag: Tag.OraclesMtree;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category entry builder
 */
export interface EntParamsOraclesMtree1 extends EntParamsOraclesMtree1Type {
}
/**
 * @category entry builder
 */
type EntUnpackedOraclesMtree1Type = EntUnpackedComplex & {
    tag: Tag.OraclesMtree;
    version: 1;
};
/**
 * @category entry builder
 */
export interface EntUnpackedOraclesMtree1 extends EntUnpackedOraclesMtree1Type {
}
/**
 * @category entry builder
 */
type EntParamsAccountsMtree1Type = Omit<EntParamsComplex & {
    tag: Tag.AccountsMtree;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category entry builder
 */
export interface EntParamsAccountsMtree1 extends EntParamsAccountsMtree1Type {
}
/**
 * @category entry builder
 */
type EntUnpackedAccountsMtree1Type = EntUnpackedComplex & {
    tag: Tag.AccountsMtree;
    version: 1;
};
/**
 * @category entry builder
 */
export interface EntUnpackedAccountsMtree1 extends EntUnpackedAccountsMtree1Type {
}
/**
 * @category entry builder
 */
type EntParamsGaMetaTxAuthData1Type = Omit<EntParamsComplex & {
    tag: Tag.GaMetaTxAuthData;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category entry builder
 */
export interface EntParamsGaMetaTxAuthData1 extends EntParamsGaMetaTxAuthData1Type {
}
/**
 * @category entry builder
 */
type EntUnpackedGaMetaTxAuthData1Type = EntUnpackedComplex & {
    tag: Tag.GaMetaTxAuthData;
    version: 1;
};
/**
 * @category entry builder
 */
export interface EntUnpackedGaMetaTxAuthData1 extends EntUnpackedGaMetaTxAuthData1Type {
}
/**
 * @category entry builder
 */
export type EntParams = EntParamsAccount1 | EntParamsAccount2 | EntParamsName1 | EntParamsContract1 | EntParamsContractCall2 | EntParamsOracle1 | EntParamsChannel3 | EntParamsChannelOffChainUpdateTransfer1 | EntParamsChannelOffChainUpdateDeposit1 | EntParamsChannelOffChainUpdateWithdraw1 | EntParamsChannelOffChainUpdateCreateContract1 | EntParamsChannelOffChainUpdateCallContract1 | EntParamsTreesPoi1 | EntParamsStateTrees0 | EntParamsMtree1 | EntParamsMtreeValue1 | EntParamsContractsMtree1 | EntParamsCallsMtree1 | EntParamsChannelsMtree1 | EntParamsNameserviceMtree1 | EntParamsOraclesMtree1 | EntParamsAccountsMtree1 | EntParamsGaMetaTxAuthData1;
/**
 * @category entry builder
 */
export type EntUnpacked = EntUnpackedAccount1 | EntUnpackedAccount2 | EntUnpackedName1 | EntUnpackedContract1 | EntUnpackedContractCall2 | EntUnpackedOracle1 | EntUnpackedChannel3 | EntUnpackedChannelOffChainUpdateTransfer1 | EntUnpackedChannelOffChainUpdateDeposit1 | EntUnpackedChannelOffChainUpdateWithdraw1 | EntUnpackedChannelOffChainUpdateCreateContract1 | EntUnpackedChannelOffChainUpdateCallContract1 | EntUnpackedTreesPoi1 | EntUnpackedStateTrees0 | EntUnpackedMtree1 | EntUnpackedMtreeValue1 | EntUnpackedContractsMtree1 | EntUnpackedCallsMtree1 | EntUnpackedChannelsMtree1 | EntUnpackedNameserviceMtree1 | EntUnpackedOraclesMtree1 | EntUnpackedAccountsMtree1 | EntUnpackedGaMetaTxAuthData1;
